import * as yup from 'yup';

export const jobPostValidationSchema = yup.object({
  // Required fields
  jobTitle: yup
    .string()
    .required('Looking for is required')
    .max(100, 'Looking for must be less than 100 characters'),
  
  jobDescription: yup
    .string()
    .required('Roles & Responsibility is required')
    .max(5000, 'Roles & Responsibility must be less than 5000 characters'),
  
  jobType: yup
    .string()
    .required('Job type is required')
    .oneOf(['full-time', 'part-time', 'contract', 'freelance', 'internship'], 'Invalid job type'),
  
  experienceLevel: yup
    .string()
    .required('Experience level is required')
    .oneOf(['entry', 'junior', 'mid', 'senior', 'manager', 'head', 'executive'], 'Invalid experience level'),
  
  noOfVacancy: yup
    .number()
    .required('Number of vacancies is required')
    .min(1, 'Must have at least 1 vacancy')
    .max(100, 'Cannot exceed 100 vacancies')
    .integer('Must be a whole number'),
  
  noticeType: yup
    .string()
    .required('Notice type is required')
    .oneOf(['immediate', '15-days', '30-days', '60-days', '90-days'], 'Invalid notice type'),

  // Required fields
  jobCategoryId: yup.string().required('Job Category is required'),
  
  salary: yup.object({
    min: yup.number()
      .transform((value, originalValue) => {
        return originalValue === '' ? undefined : value;
      })
      .required('Min salary is required')
      .positive('Min salary is required'),
    max: yup.number()
      .transform((value, originalValue) => {
        return originalValue === '' ? undefined : value;
      })
      .required('Max salary is required')
      .positive('Max salary  is required')
      .test('max-greater-than-min', 'Max salary must be greater than Min salary', function(value) {
        const { min } = this.parent;
        if (min && value) {
          return value > min;
        }
        return true;
      }),
    currency: yup.string().default('INR'),
    denomination: yup.string().required('Denomination is required').oneOf(['thousand', 'lakh', 'crore'], 'Invalid denomination'),
    period: yup.string().required('Period is required').oneOf(['hourly', 'monthly', 'yearly'], 'Invalid period').default('yearly'),
  }).required('Salary information is required'),
  
  skills: yup.array().of(yup.string().max(50, 'Skill name too long')).required('At least one skill is required').min(1, 'At least one skill is required'),
  
  location: yup.array().of(yup.string().max(100, 'Location name too long')).required('At least one location is required').min(1, 'At least one location is required'),
  
  workMode: yup
    .string()
    .required('Work mode is required')
    .oneOf(['remote', 'onsite', 'hybrid'], 'Invalid work mode'),
  
  applicationDeadline: yup
    .date()
    .required('Application deadline is required')
    .min(new Date(), 'Application deadline must be in the future'),
  
  contactDetails: yup.object({
    email: yup.string().email('Invalid email format'),
    mobile: yup.string().matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits'),
  }),
});

// Combined validation schema for job posts (includes feed-level fields)
export const createJobPostValidationSchema = yup.object({
  // Feed-level fields (title and content will be auto-generated from job fields)
  feedType: yup
    .string()
    .required('Please select a Talky type'),
  
  title: yup
    .string()
    .max(200, 'Title must be less than 200 characters'),
  
  content: yup
    .string()
    .max(5000, 'Content must be less than 5000 characters'),
    
  location: yup
    .string()
    .max(100, 'Location must be less than 100 characters'),
    
  visibility: yup
    .string()
    .oneOf(['public', 'private', 'connections'], 'Invalid visibility option')
    .required('Visibility is required'),
    
  tags: yup
    .array()
    .of(yup.string())
    .required('At least one tag is required')
    .min(1, 'At least one tag is required')
    .max(10, 'Maximum 10 tags allowed'),

  // Job-specific fields
  feedSpecificData: jobPostValidationSchema,
});